// This is intended, to use the MUI button here.
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Styled answer options need the MUI button primitive.
import { Button, Stack } from '@mui/material';
import styled from 'styled-components';

export const ChoiceSelectorCard = styled(Stack)`
  && {
    padding: 0.75rem;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: ${({ theme }) => theme.shape.containerRadius};
    background-color: ${({ theme }) => theme.palette.background.paper};
    gap: 0.75rem;
  }
`;

export const ChoiceAnswerButton = styled(Button)`
  && {
    ${({ theme }) => theme.typography.p8};
    text-transform: none;
    justify-content: flex-start;
    padding: 0.5rem 0.75rem;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: ${({ theme }) => theme.shape.tooltipRadius};
    color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.background.default};

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.light};
      border-color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;
